import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop/entry-points/ApolloErrorInterop.ts';
import { isApolloError } from '@confluence/apollo-relay-interop/entry-points/ApolloErrorInterop.ts';
import { getStatusCode } from '@confluence/error-boundary/entry-points/isStatusCodeError.ts';

export const shouldMarkErrorAsHandled = (
	error: ApolloErrorInterop | Error | undefined,
): boolean => {
	if (!error) return true;
	const statusCode = isApolloError(error)
		? getStatusCode(error?.graphQLErrors?.[0])
		: getStatusCode(error);
	if (!statusCode) return true;
	return !!(parseInt(statusCode) >= 400 && parseInt(statusCode) < 500);
};
